var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:_vm.$route.path=='/isoti'?['isoti']:[]},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }